export default __webpack_public_path__ + "static/9-26d45c141078330746dee500e8be9196.png";